import CarotekColors from "@carotek/utils/Colors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    headerLinksWrapper?: InjectableCss;
    headerCTAWrapper?: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
            padding: 24px 20px 10px;
            max-width: 1440px;
            margin: 0 auto;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding: 15px 15px 15px;
                            flex-wrap: wrap;
                            justify-content: flex-end;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    logoWrapper: {
        css: css`
            text-align: left;
            //padding: 20px 45px;
            //margin: 0 24px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-grow: 1;
                            .wrapper {
                                a {
                                    width: 100%;
                                    ${TypographyStyle} {
                                        width: 100%;
                                        > div {
                                            width: 100%;
                                            img {
                                                width: 40%;
                                            }
                                        }
                                    }
                                }
                            }
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            img {
                height: 78px;
                width: auto;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                height: auto;
                                width: auto;
                                margin: 0;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }};
            }
        `,
    },
    searchMenuWrapper: {
        css: css`
            text-align: right;
            //padding: 20px 45px;
            display: flex;
            flex-direction: column;

            [class^="Wrapper"] {
                width: auto;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    linkListHidden: {
        below: "lg",
    },
    headerLinksWrapper: {
        css: css`
            display: flex;

            .top-rgt-navigation {
                display: flex;
                transform: translateY(-2px);
                align-items: center;
            }

            .contact-num {
                display: block;
                margin-right: 10px;
                padding-right: 10px;
                border-right: 1px solid ${getColor("common.border")};
                span[class^="TypographyStyle"] {
                    font-family: OpenSansBold;
                    line-height: 1;
                    font-weight: bold;

                    font-size: 24px !important;
                    color: ${getColor("danger")} !important;

                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                css`
                                    font-size: 14px !important;
                                `,
                                null,
                                null,
                                null,
                            ],
                            "max",
                        )}

                    :hover {
                        text-decoration: underline;
                    }
                }
            }

            .contact-us {
                padding: 8px 5px 7px;
                background-color: ${getColor("danger")};
                vertical-align: top;
                display: inline-block;
                margin-bottom: 0px;
                line-height: 9px;
                margin-left: 3px;
                span[class^="TypographyStyle"] {
                    font-size: 13px;
                    font-family: OpenSansBold;
                    font-weight: bold;
                    color: ${CarotekColors.white} !important;

                    :hover {
                        text-decoration: underline;
                    }
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-wrap: wrap;
                            flex-direction: column-reverse;
                            position: relative;
                            .list-wrapper {
                                padding: 0;
                                display: flex;
                                font-size: 10px;
                                margin: 0;
                                text-align: right;
                                justify-content: end;
                                margin: 15px 0;
                                .list-link {
                                    padding-right: 5px;
                                    margin-right: 5px;
                                    p {
                                        color: #7d7e81 !important;
                                        font-size: 10px;
                                    }
                                }
                            }
                            .top-rgt-navigation {
                                display: flex;
                                justify-content: end;
                                width: 60%;
                                position: absolute;
                                right: 0;
                                top: -30px;
                                .contact-num {
                                    font-size: 12px;
                                    margin-right: 2px;
                                    padding-right: 5px;
                                    span {
                                        font-size: 12px;
                                    }
                                }
                                .contact-us span {
                                    font-size: 10px;
                                    line-height: 10px;
                                }
                            }
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    headerCTAWrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            [data-test-selector="HeaderSearchInput"] {
                                display: none;
                            }
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
};

const LogoLinksSearch: React.FC<PageProps> = ({ id }) => (
    <StyledWrapper {...logoLinksSearchStyles.container}>
        <StyledWrapper {...logoLinksSearchStyles.logoWrapper}>
            <Zone contentId={id} zoneName="Logo" fixed />
        </StyledWrapper>
        <StyledWrapper {...logoLinksSearchStyles.searchMenuWrapper}>
            <StyledWrapper {...logoLinksSearchStyles.headerLinksWrapper}>
                <Zone contentId={id} zoneName="LinkList" fixed />
                <Zone contentId={id} zoneName="HeaderData" fixed />
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.headerCTAWrapper}>
                <Zone contentId={id} zoneName="Search" fixed />
                <Zone contentId={id} zoneName="SignIn" fixed />
                <Zone contentId={id} zoneName="Cart" fixed />
            </StyledWrapper>
        </StyledWrapper>
    </StyledWrapper>
);

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Common",
        icon: "magnifying-glass",
    },
};

export default logoLinksSearch;
